module.exports = __webpack_public_path__ + "static/media/logo-deltares.857463c9.svg";